import { useState } from "react";
import i18n from "i18next";
import { DocumentsOfObjectDataGrid } from "src/components/views/documents/objectDocuments/DocumentsOfObjectDataGrid.tsx";
import { DocumentPreviewView } from "src/components/views/documents/preview/DocumentPreviewView.tsx";
import { useRefreshRef } from "src/utils/useRefreshRef.ts";
import { DocumentConnectionView } from "src/api/generated/postgres/db/types/documents/tables/documentConnectionView.ts";
import { AavoObjectRef } from "src/api/generated/common/sourceType/aavoObjectRef.ts";
import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import { useMediaQueryBreakpointUp } from "src/utils/breakpointUtils.ts";

export interface DocumentsOfObjectViewProps {
	objectRef: AavoObjectRef;
	editable?: boolean;
}

export const DocumentsOfObjectView = ({
	objectRef,
	editable = true,
}: DocumentsOfObjectViewProps) => {
	const [selectedDocument, setSelectedDocument] = useState<DocumentConnectionView | undefined>(
		undefined,
	);

	const showPreview = useMediaQueryBreakpointUp("md");
	const previewViewRefreshRef = useRefreshRef();

	const documentsOfObjectDataGrid = (
		<DocumentsOfObjectDataGrid
			objectRef={objectRef}
			editable={editable}
			onSelectionChanged={(docs) => setSelectedDocument(docs[0])}
			onDocumentFileChanged={() => {
				previewViewRefreshRef.current?.refresh();
			}}
		/>
	);

	if (!showPreview) return documentsOfObjectDataGrid;

	return (
		<AavoMosaic
			viewId={"58D9749A534DEFB8"}
			layout={{
				type: "row",
				first: {
					type: "panel",
					title: i18n.t("documents"),
					content: documentsOfObjectDataGrid,
				},
				second: {
					type: "panel",
					title: i18n.t("preview"),
					content: (
						<DocumentPreviewView
							key={selectedDocument?.documentId}
							documentId={selectedDocument?.documentId}
							refreshRef={previewViewRefreshRef}
						/>
					),
				},
			}}
		/>
	);
};
